/** @jsxImportSource @emotion/react */
import { css, Box, Typography, IconButton } from "@mui/material"
import { Delete } from "@mui/icons-material"
import { withMyTheme } from "../../../../theme/theme"

const CardStyle = withMyTheme((theme) => css`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    border-radius: 12px;
    border: 1.5px solid ${theme.palette.primary.light};
    background: white;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        border-color: ${theme.palette.primary.main};
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }
`)

const IconWrapperStyle = (iconColor?: string) => withMyTheme(() => css`
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 36px;
    height: 36px;

    svg {
        color: ${iconColor};
    }
`)

const TextContainerStyle = withMyTheme(() => css`
    flex: 1;
    min-width: 0;
    text-align: left;
`)

const TitleStyle = withMyTheme((theme) => css`
    font-family: ${theme.typography.body1.fontFamily};
    font-weight: 500;
    font-size: 1rem;
    color: ${theme.palette.text.primary};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`)

const SubtitleStyle = withMyTheme((theme) => css`
    font-family: ${theme.typography.body1.fontFamily};
    font-size: 0.8rem;
    color: ${theme.palette.text.secondary};
    margin-top: 0.1rem;
`)

const DeleteButtonStyle = withMyTheme((theme) => css`
    color: ${theme.palette.text.secondary};
    flex-shrink: 0;

    &:hover {
        color: ${theme.palette.error.main};
    }
`)

interface SectionCardProps {
    title: string
    subtitle?: string
    icon: React.ReactNode
    isMuiIcon: boolean
    primaryColor: string
    onClick: () => void
    onDelete: () => void
}

export const SectionCard = ({ title, subtitle, icon, isMuiIcon, primaryColor, onClick, onDelete }: SectionCardProps) => {
    const handleDelete = (e: React.MouseEvent) => {
        e.stopPropagation()
        onDelete()
    }

    return (
        <Box css={CardStyle} onClick={onClick}>
            <Box css={IconWrapperStyle(isMuiIcon ? primaryColor : undefined)}>
                {icon}
            </Box>
            <Box css={TextContainerStyle}>
                <Typography css={TitleStyle}>
                    {title}
                </Typography>
                {subtitle && (
                    <Typography css={SubtitleStyle}>
                        {subtitle}
                    </Typography>
                )}
            </Box>
            <IconButton css={DeleteButtonStyle} size="small" onClick={handleDelete}>
                <Delete fontSize="small" />
            </IconButton>
        </Box>
    )
}
